/* Auto-generated file created by dtovbeinJC 05/11/2018 at 23:26:10hs */

import { ARTICLES } from "../../constants/";
import {} from "./actions";
import {GET_ARTICLES} from "./actions";
import {SET_WINDOWS_SIZE_TYPE} from "../App/actions";
import {EXTRA_SMALL, LARGE, MEDIUM, SMALL } from "../../constants/shared";
import {GET_ALL} from "../../actions/api";
import {GET_COURSES} from "../Courses/actions";

export const initialState = {
  name: "",
  articles: null,
  layout: {
    columns: 1,
    rows: 1
  }
}

export default function reducer(state=initialState, action) {
  switch(action.type) {
    case ARTICLES: {
      return {
        ...state,
        name: action.payload.name
      };
    }

    case `${GET_ALL}_ARTICLE_REQUEST`: {
      return {
        ...state
      }
    }

    case `${GET_ALL}_ARTICLE_SUCCESS`: {
      return {
        ...state,
        articles: action.payload
      }
    }

    case `${GET_COURSES}_ARTICLE_FAILED`: {
      return {
        ...state
      }
    }

    case SET_WINDOWS_SIZE_TYPE: {
      const { type } = action.payload;
      return {
        ...state,
        layout: {
          columns: (type === EXTRA_SMALL || type === SMALL) ? 1 : (type === MEDIUM) ? 2 : 4,
          rows: (type === EXTRA_SMALL || type === SMALL || type === MEDIUM) ? 2 : 2,
        }
      };
    }

    default:
      return state;
  }
}